import UPDATE_ITEM_MUTATION from "@/queries/Cart/AddItem.mutation.gql"
import CURRENT_QUERY from "@/queries/Current.query.gql"

export default {
  props: {
    listing: Object,
  },
  render() {
    return this.$scopedSlots.default({
      appendAddon: this.appendAddon,
    })
  },
  methods: {
    appendAddon(frame) {
      this.$emit("adding")

      this.$apollo.mutate({
        mutation: UPDATE_ITEM_MUTATION,
        variables: {
          listingId: this.listing.id,
          framing: frame,
        },
        update: (store, { data: { addCartItem } }) => {
          const query = CURRENT_QUERY
          const data = store.readQuery({ query })

          data.checkoutCart = addCartItem.cart
          store.writeQuery({ query, data })

          const event = new CustomEvent("cart:frame-change", { detail: frame })
          window.dispatchEvent(event)
        },
      })
    },
  },
}
